/**
 * von / bis slider fuer z.b. datenvolumen oder grundgebuehr
 */
export class RangeSlider {
    constructor(viewRoot: HTMLElement) {
        const sliderContainers: NodeListOf<HTMLElement> = viewRoot.querySelectorAll('.slider-range .range');

        if (sliderContainers.length <= 0) {
            return;
        }

        sliderContainers.forEach((container: HTMLElement) => {
            const initMethod: string | undefined = container.dataset.initmethod;

            if (initMethod) {
                const method = (window as any)[initMethod];
                if (typeof method === 'function') {
                    method();
                }
            }
        });
    }
}
